'use strict';

/** @type {import('.').AsyncGeneratorFunctionConstructor | false} */
var cached;

/** @type {import('.')} */
module.exports = function getAsyncGeneratorFunction() {
	if (typeof cached === 'undefined') {
		try {
			// eslint-disable-next-line no-new-func
			cached = Function('return async function* () {}')().constructor;
		} catch (e) {
			cached = false;
		}
	}
	return cached;
};




//////////////////
// WEBPACK FOOTER
// ./~/async-generator-function/legacy.js
// module id = 316
// module chunks = 1